<div class="autocomplete-card"
     [class.is-active]="active()"
     [class.is-out-of-stock]="isOutOfStock()"
     (mousedown)="$event.preventDefault()"
     (click)="onProductClick($event)">
  <div class="autocomplete-card__image">
    <img
      [src]="product().img || 'assets/images/product-placeholder.webp'"
      [alt]="product().name"
      loading="lazy"
      (error)="onImageError($event)">
    @if (badgeText()) {
      <span class="autocomplete-card__badge">{{ badgeText() }}</span>
    }
  </div>

  <div class="autocomplete-card__content">
    <h4 class="autocomplete-card__name" [title]="product().name">
      {{ product().name }}
    </h4>

    @if (product().producerName) {
      <p class="autocomplete-card__producer">{{ product().producerName }}</p>
    }

    <!-- One chip only: the card is a 6-up grid cell. Out of stock stays first (it is the
         harder no), then the cut-off, then the stock nudges. -->
    @if (isOutOfStock()) {
      <span class="autocomplete-card__oos-chip">Out of stock</span>
    } @else if (isCutOffClosed()) {
      <span class="autocomplete-card__cutoff-chip">Closed for this delivery</span>
    } @else if (isLowStock()) {
      <span class="autocomplete-card__low-stock">{{ lowStockText() }}</span>
    } @else if (cutOffNotice()) {
      <span class="autocomplete-card__cutoff-notice">{{ cutOffNotice() }}</span>
    }

    <div class="autocomplete-card__footer">
      <div class="autocomplete-card__price">
        @if (hasDiscount()) {
          <span class="autocomplete-card__price--original">${{ product().originalPrice | number:'1.2-2' }}</span>
        }
        <span class="autocomplete-card__price--current" [class.on-sale]="hasDiscount()">
          ${{ product().price | number:'1.2-2' }}
        </span>
      </div>

      <button
        class="autocomplete-card__add-btn"
        type="button"
        [disabled]="isLoading()"
        (click)="onAddToCart($event)"
        [title]="canQuickAdd() ? 'Quick add to cart' : 'View product'">
        @if (isLoading()) {
          <i class="fa-solid fa-spinner fa-spin"></i>
        } @else if (canQuickAdd()) {
          <i class="fa-solid fa-plus"></i>
        } @else {
          <i class="fa-solid fa-arrow-right"></i>
        }
      </button>
    </div>
  </div>
</div>
